import * as React from "react";

function SvgPlateTypeCalibration(props: React.SVGProps<SVGSVGElement>) {
  return (
    <svg width="1em" height="1em" viewBox="0 0 24 24" fill="none" {...props}>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M17 24a7 7 0 100-14 7 7 0 000 14zm0-1a6 6 0 100-12 6 6 0 000 12z"
        fill="#fff"
      />
      <path
        d="M21.23 10.673L24 8.819c-.262-.922-.636-1.8-1.106-2.62l-.227-.379a12.12 12.12 0 00-1.814-2.251l-3.047 1.385c-.716-.55-1.518-1-2.382-1.329l-.28-3.239A12.897 12.897 0 0012 0c-.901 0-1.78.092-2.627.268L8.956 3.49a9.42 9.42 0 00-2.762 1.464L3.147 3.569a12.118 12.118 0 00-1.814 2.25l-.228.38a11.713 11.713 0 00-.953 2.129l2.685 1.96a8.737 8.737 0 00-.068 3.039L0 15.181c.262.922.636 1.8 1.106 2.62l.227.38c.42.671.905 1.3 1.448 1.878l3.102-1.262c.792.663 1.701 1.2 2.693 1.578l.28 3.239C9.86 23.866 10.914 24 12 24c1.086 0 2.14-.134 3.144-.386l.076-.882a6.008 6.008 0 01-4.148-4.798C8.077 17.502 5.78 15.01 5.78 12c0-3.314 2.785-6 6.221-6 3.122 0 5.707 2.219 6.153 5.11a5.988 5.988 0 013.141 1.7 8.776 8.776 0 00-.063-2.137zM22.172 13.957a5.973 5.973 0 01.79 3.724 11.68 11.68 0 001.038-2.5l-1.828-1.223z"
        fill="#fff"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M20 15v4h-6v-3.368l.75-.632H20zm-5.25.632h.75v.631h-.75v-.631zm1.25 0h.75v.631H16v-.631zm2 0h-.75v.631H18v-.631zm.5 0h.75v.631h-.75v-.631zm-3.75 1.052h.75v.632h-.75v-.632zm1.25 0h.75v.632H16v-.632zm2 0h-.75v.632H18v-.632zm.5 0h.75v.632h-.75v-.632zm-3 1.053h-.75v.631h.75v-.631zm1.25 0H16v.631h.75v-.631zm.5 0H18v.631h-.75v-.631zm2 0h-.75v.631h.75v-.631z"
        fill="#fff"
      />
      <path
        d="M15 13h4v1h-4v-1zM21 15h1v4h-1v-4zM12 15h1v4h-1v-4zM15 20h4v1h-4v-1z"
        fill="#fff"
      />
    </svg>
  );
}

export default SvgPlateTypeCalibration;
